import(/* webpackMode: "eager" */ "/app/src/app/products/resQ/page.tsx");
